import React, { useContext, forwardRef } from "react";
import { styled } from '@mui/material/styles';
import { BoerderyContext } from "../../../context/boerdery-context";
import { ProfielContext } from "../../../context/profiel-context";
import { NavLink } from "react-router-dom";

import {
  Button,
  ListItem,
  Divider,
} from "@mui/material";
import AktiwiteiteIcon from "@mui/icons-material/Build";
import { withTranslation } from "react-i18next";

const PREFIX = 'Modules';

const classes = {
  item: `${PREFIX}-item`,
  modulesHeading: `${PREFIX}-modulesHeading`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.item}`]: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },

  [`& .${classes.modulesHeading}`]: {
    marginTop: 5,
    marginBottom: 5,
    textTransform: "uppercase",
    color: theme.palette.primary.light,
    fontWeight: 700,
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <NavLink {...props} />
  </div>
));

const Modules = ({ t }) => {
  const boerderyContext = useContext(BoerderyContext);
  const profielContext = useContext(ProfielContext);



  return (
    <Root>
      {profielContext.profiel.modulestoelatings &&
        boerderyContext.modules.length > 0 ? (
        <React.Fragment>
          <Divider style={{ marginTop: 5 }} />
          <h5 className={classes.modulesHeading}>Modules</h5>
          {profielContext.profiel.modulestoelatings
            .map((itm) => itm.module)
            .indexOf("aktiwiteite") !== -1 &&
            boerderyContext.modules.indexOf("aktiwiteite") !== -1 ? (
            <ListItem className={classes.item} disableGutters>
              <Button
                variant="navigation"
                startIcon={<AktiwiteiteIcon />}
                component={CustomRouterLink}
                to={"/aktiwiteite/take"}
              >
                {t("Aktiwiteite")}
              </Button>
            </ListItem>
          ) : null}
        </React.Fragment>
      ) : null}
    </Root>
  );
};

export default withTranslation(["translation"])(Modules);
